import { projects, units, paymentMethods, passwordRecoveryModal, editImage, changePasswordModal, profileForm, floorsList, catalogSettingsModal, filters, login, countries, } from 'i18n/ru.common';
export default {
    translation: {
        main: {
            statistics: {
                tooltipText: 'С прошлого обновления',
                tooltipPreLaunchText: 'Начальная стоимость',
                chartPreLaunchPointText: 'Старт продаж',
            },
            metroStation: {
                line: '{{lineCode}} линия',
                plannedStation: 'планируемая станция',
                builtStation: 'построенная станция',
                subtitle: 'Станция метро',
            },
            header: {
                title: { ...projects },
                search: {
                    placeholder: 'Поиск по названию проекта или застройщика',
                    noMatch: 'Нет результатов',
                },
            },
            districtView: {
                description: 'Описание',
                descriptionShow: 'Показать',
                descriptionHide: 'Скрыть',
                developers: 'Застройщики',
                places: 'Места',
                projectsCount_one: '{{count}} проект',
                projectsCount_two: '{{count}} проекта',
                projectsCount_few: '{{count}} проекта',
                projectsCount_many: '{{count}} проектов',
                projectsCount_other: '{{count}} проектов',
                from: 'От',
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                descriptionShow: 'Показать',
                descriptionHide: 'Скрыть',
                addToCatalog: 'Добавить в каталог',
                floor: 'этаж',
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: 'Цена с комиссией',
                priceWithoutCommission: 'Цена без комиссии',
                unitFeature: 'Особенность юнита',
                unitView: 'Вид из окна',
                unitsOnRequestHint: {
                    start: 'Некоторые юниты в продаже от застройщика доступны по запросу у ',
                    link: 'менеджера',
                    end: '',
                },
                unitsOnRequestBlockTitle: 'Юниты по запросу',
                unitsOnRequestBlockTitleSome: 'Некоторые юниты от застройщика по запросу',
                unitsOnRequestBlockDescription: 'Свяжитесь с менеджером, чтобы получить подробности о юнитах в этом проекте.',
                unitContactsAria: 'Контакты по продаже юнита',
                unitContactsModalTitle: 'Контакты',
                unitContactsModalOk: 'Ок',
                tabs: {
                    information: {
                        title: 'Информация',
                        developer: 'Застройщик',
                        district: 'Район',
                        price: 'Цена',
                        pricePerSquare: 'Цена за',
                        size: 'Площадь',
                        postHandover: 'Постоплата',
                        handover: {
                            title: 'Готовность',
                            ready: 'Сдан',
                        },
                        ownershipType: {
                            title: 'Тип владения',
                            leasehold: 'Арендное владение',
                            freehold: 'Полная собственность',
                        },
                        unitType: 'Тип юнита',
                        serviceCharge: {
                            TH: 'Обслуживание',
                            default: 'Обслуживание',
                        },
                        furnishing: 'Отделка',
                        startOfSales: 'Старт продаж',
                        eoi: {
                            title: {
                                MX: 'Платёж за бронирование',
                                default: 'Взнос по EOI',
                            },
                            from: 'От',
                            upTo: 'До',
                            hint: {
                                MX: 'Итоговая сумма платежа за бронирование зависит от выбранного юнита и условий продавца.',
                                default: 'Итоговая сумма EOI зависит от выбранного юнита и условий продавца.',
                            },
                        },
                        noc: 'Resale доступен после',
                        projectConfigurations: 'Конфигурации проекта',
                        managersContacts: 'Контакты застройщика',
                        managersName: 'Имя',
                        managersPhone: 'Телефон',
                        hide: 'Скрыть',
                        show: 'Показать',
                        yes: 'Да',
                        no: 'Нет',
                    },
                    units: {
                        title: 'Юниты',
                        ...units,
                        from: 'от',
                        floor: 'этаж',
                        resale: 'Resale',
                        distress: 'Distress',
                        priceWithCommission: 'Цена с комиссией',
                        priceWithoutCommission: 'Цена без комиссии',
                        unitFeature: 'Особенность юнита',
                        unitView: 'Вид из окна',
                    },
                    amenities: {
                        title: 'Удобства',
                    },
                    paymentPlans: {
                        title: 'План оплаты',
                        postHandover: 'С пост оплатой',
                        noPostHandover: 'Без пост оплаты',
                        ...paymentMethods,
                    },
                    documentsAndVideos: {
                        title: 'Документы и видео',
                    },
                    placesNearby: {
                        title: 'Места рядом',
                    },
                    seller: {
                        title: 'Продавец',
                        salesManagers: 'Менеджеры по продажам',
                        salesManagersDescription: 'Контакты',
                        resaleContactsHint: 'Контакты для ресейл юнитов указаны в его карточке.',
                        comission: 'Комиссия',
                        comissionDescription: 'Применимая комиссия',
                        comissionItemDescription: 'Ставка на сделки',
                        address: 'Расположение офиса',
                        descriptionShow: 'Показать',
                        descriptionHide: 'Скрыть',
                        clipboard: 'Скопировано!',
                    },
                },
                placesNearby: {
                    meters: 'метров',
                },
                seller: {
                    title: 'Продавец',
                    salesManagers: 'Менеджеры по продажам',
                    salesManagersDescription: 'Контакты',
                    resaleContactsHint: 'Контакты для ресейл юнитов указаны в его карточке.',
                    commission: 'Комиссия',
                    commissionDescription: 'Применимая комиссия',
                    commissionItemDescription: 'Ставка на сделки',
                    address: 'Расположение офиса',
                    descriptionShow: 'Показать',
                    descriptionHide: 'Скрыть',
                    clipboard: 'Скопировано!',
                },
            },
        },
        personal: {
            companies: {
                broker: 'Брокер',
                developer: 'Застройщик',
                agency: 'Агенство',
            },
        },
        settings: {
            title: 'Настройки',
            profile: {
                title: 'Профиль',
            },
            language: {
                title: 'Язык',
                ru: 'Русский',
                en: 'Английский',
                ar: "Арабский",
            },
            currency: {
                title: 'Валюта',
            },
            measures: {
                title: 'Единицы измерения',
            },
            map: {
                title: 'Карта',
            },
            showDistricts: {
                title: 'Показывать районы на карте',
            },
        },
        profile: {
            title: 'Профиль',
            changePassword: 'Изменить пароль',
            logout: 'Выйти',
            cancel: 'Отмена',
            save: 'Сохранить',
        },
        catalog: {
            title: 'Каталог',
            clear: 'Очистить',
            preview: 'Предпросмотр',
            floor: 'этаж',
            ...floorsList,
            empty: {
                title: 'Ваш каталог пуст',
                description: 'Добавьте проекты или объекты из карты, чтобы начать работать с вашим каталогом',
                button: 'Перейти на карту',
            },
        },
        preview: {
            title: 'Предпросмотр',
            generate: 'Создать каталог',
        },
        login,
        resetPassword: {
            header: 'Восстановление пароля',
            body: 'Создайте новый пароль. Он должен быть не менее 8 символов и включать хотя бы одну заглавную и строчную букву, цифру и символ.',
            uppercaseAndLowercaseLetterTitle: 'Пароль обязательно должен содержать минимум одну строчную и одну заглавную букву.',
            oneDigitTitle: 'Пароль обязательно должен содержать минимум одну цифру.',
            specialSymbolTitle: 'Пароль обязательно должен содержать минимум один специальный символ.',
            minimumLengthTitle: 'Длина пароля обязательно должна быть не менее 8 символов.',
            password: 'Новый пароль',
            passwordConfirmation: 'Подтвердите новый пароль',
            passwordSubmited: {
                header: 'Теперь у вас новый пароль!',
                body: 'Новый пароль успешно создан, теперь вы можете  использовать его для входа в Geniemap.',
            },
            createPassword: 'Создать пароль',
            ok: 'Ок',
        },
        projectsList: {
            projects_one: '{{ count }} проект',
            projects_two: '{{ count }} проекта',
            projects_few: '{{ count }} проекта',
            projects_many: '{{ count }} проектов',
            projects_other: '{{ count }} проектов',
            noResultsFound: 'Результат не найден',
            tryDifferentSearchOptions: 'Попробуйте использовать другие поисковые опции',
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: 'Цена от',
                handover: 'Передача',
            },
        },
        common: {
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            countries: countries,
        },
        ws: {
            catalog: {
                start_catalog_generate: 'Каталог начал генерироваться.',
                catalog_generated: 'Каталог успешно создан',
                warning: 'Предупреждение',
            },
            auth: {
                logout: 'Вы были разлогинены в связи с большим количеством подключений из под вашего аккаунта.',
            },
        },
    },
};
